import { render, staticRenderFns } from "./PayAccountEchart.vue?vue&type=template&id=2b7d9670&scoped=true"
import script from "./PayAccountEchart.vue?vue&type=script&lang=js"
export * from "./PayAccountEchart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7d9670",
  null
  
)

export default component.exports